document.addEventListener('DOMContentLoaded', () => {
  const targets = ['#field_3_27', '#field_3_28'];

  // Function to get URL parameters
  const getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  const emailParam = getUrlParameter('email');

  if (emailParam) {
    const emailObserver = new MutationObserver(() => {
      const emailInput = document.querySelector('#input_3_13');
      if (emailInput) {
        emailInput.value = emailParam;
        emailObserver.disconnect();
        console.log('Email field populated with:', emailParam);
      }
    });

    emailObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  const showTab = (targetId) => {
    targets.forEach(id => {
      const el = document.querySelector(id);
      if (el) el.style.display = 'none';
    });

    const target = document.querySelector(targetId);
    if (target) target.style.display = 'block';
  };

  const setActive = (index) => {
    const tabs = document.querySelectorAll('#form-tabs .tablink');
    tabs.forEach(tab => tab.classList.remove('active'));
    const activeTab = [...tabs].find(tab => tab.dataset.index === index.toString());
    if (activeTab) activeTab.classList.add('active');
  };

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('#form-tabs .tablink');
    if (!tab) return;

    const targetId = tab.dataset.target;
    const index = tab.dataset.index;
    if (!targetId || !index) return;

    showTab(targetId);
    setActive(index);
  });

  const observer = new MutationObserver(() => {
    const el = document.querySelector('#form-tabs .tablink');
    if (el) {
      showTab('#field_3_27');
      setActive(1);
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
